import { FracGroupWellBase } from './base/frac-group-well-base';

export class FracGroupWell extends FracGroupWellBase { }